import React from "react";
import Col from "react-bootstrap/Col";
import NoImage from "../static/noimage.svg";
import { Link } from "react-router-dom";

function GeneralGridItem(props) {
  const { name, totalProducts, imgUrl, type, id } = props;
  return (
    <Col lg={3} sm={6} md={6} xs={6} className="even-spacer-y">
      {totalProducts > 0 ? (
        <Link
          to={`/products/${type === "brand" ? "brand" : "category"}/${id}`}
          className="gci"
        >
          <div className="upperContent">
            <div>
            <img
              className="img-fluid-2"
              alt={name}
              src={imgUrl === "" ? NoImage : imgUrl}
            />
            </div>

            
          </div>
          <div className="lowerContent">
            <span className="item-name">{name}</span>
            <span className="item-count">
              {totalProducts} {totalProducts > 1 ? "Products" : "Product"}
            </span>
          </div>
        </Link>
      ) : (
        <div className="gci noClick">
          <div className="upperContent">
            <div>
            <img
              className="img-fluid-2"
              alt={name}
              src={imgUrl === "" ? NoImage : imgUrl}
            />
            </div>
            
          </div>
          <div className="lowerContent">
            <span className="item-name">{name}</span>
            <span className="item-count">
              {totalProducts} {totalProducts > 1 ? "Products" : "Product"}
            </span>
          </div>
        </div>
      )}
    </Col>
  );
}

export default GeneralGridItem;
